<template>
  <ons-page id="notification-settings">
    <app-bar :title="$t('notf_settings.title')" :enable-home="false" />
    <form action="" class="form">
      <ons-list>
        <ons-list-item>
          <div class="center">{{ $t('notf_settings.all_notf') }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="!currentUser.all_notf_disabled"
              :disabled="isOffline"
              @change="toggleAllNotfDisabled($event)"
            />
            <icon-progress-circular v-show="allNotfDisabledLoading" />
          </div>
        </ons-list-item>
      </ons-list>
      <div class="account-gap no-border">{{ $t('notf_settings.all_push_notf') }}</div>
      <ons-list>
        <ons-list-item>
          <div class="center">{{ $t('notf_settings.new_ep_from_sub_push_notf') }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="currentUser.new_ep_from_sub_push_notf_enabled"
              :disabled="currentUser.all_notf_disabled || isOffline"
              @change="toggleNewEpFromSubPushNotfEnabled($event)"
            />
            <icon-progress-circular v-show="newEpFromSubPushNotfEnabledLoading" />
          </div>
        </ons-list-item>
        <ons-list-item>
          <div class="center">{{ $t('notf_settings.new_recommendation_push_notf') }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="currentUser.new_recommendation_push_notf_enabled"
              :disabled="currentUser.all_notf_disabled || isOffline"
              @change="toggleNewRecommendationPushNotfEnabled($event)"
            />
            <icon-progress-circular v-show="newRecommendationPushNotfEnabledLoading" />
          </div>
        </ons-list-item>
        <ons-list-item>
          <div class="center">{{ $t('notf_settings.new_featured_push_notf') }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="currentUser.new_featured_push_notf_enabled"
              :disabled="currentUser.all_notf_disabled || isOffline"
              @change="toggleNewFeaturedPushNotfEnabled($event)"
            />
            <icon-progress-circular v-show="newFeaturedPushNotfEnabledLoading" />
          </div>
        </ons-list-item>
      </ons-list>
      <div class="account-gap no-border">{{ $t('notf_settings.all_email_notf') }}</div>
      <ons-list>
        <ons-list-item>
          <div class="center">{{ $t('notf_settings.new_ep_from_sub_email_notf') }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="currentUser.new_ep_from_sub_email_notf_enabled"
              :disabled="currentUser.all_notf_disabled || isOffline"
              @change="toggleNewEpFromSubEmailNotfEnabled($event)"
            />
            <icon-progress-circular v-show="newEpFromSubEmailNotfEnabledLoading" />
          </div>
        </ons-list-item>
        <ons-list-item>
          <div class="center">{{ $t('notf_settings.new_recommendation_email_notf') }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="currentUser.new_recommendation_email_notf_enabled"
              :disabled="currentUser.all_notf_disabled || isOffline"
              @change="toggleNewRecommendationEmailNotfEnabled($event)"
            />
            <icon-progress-circular v-show="newRecommendationEmailNotfEnabledLoading" />
          </div>
        </ons-list-item>
        <ons-list-item>
          <div class="center">{{ $t('notf_settings.new_featured_email_notf') }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="currentUser.new_featured_email_notf_enabled"
              :disabled="currentUser.all_notf_disabled || isOffline"
              @change="toggleNewFeaturedEmailNotfEnabled($event)"
            />
            <icon-progress-circular v-show="newFeaturedEmailNotfEnabledLoading" />
          </div>
        </ons-list-item>
        <ons-list-item>
          <div class="center">{{ $t('notf_settings.newsletter_email_notf') }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="currentUser.newsletter_email_notf_enabled"
              :disabled="currentUser.all_notf_disabled || isOffline"
              @change="toggleNewsletterEmailNotfEnabled($event)"
            />
            <icon-progress-circular v-show="newsletterEmailNotfEnabledLoading" />
          </div>
        </ons-list-item>
      </ons-list>
    </form>
    <v-ons-toast :visible="shouldShowGoOnlineToast" animation="ascend">
      {{ $t("messages.go_online_to_change_settings") }}
      <button @click="goOnline">{{ $t("ui.go_online") }}</button>
    </v-ons-toast>
  </ons-page>
</template>

<script>
import AppBar from '@/components/AppBar.vue';

export default {
  name: 'notification-settings',
  components: {
    'app-bar': AppBar
  },

  data() {
    return {
      allNotfDisabledLoading: false,
      newEpFromSubPushNotfEnabledLoading: false,
      newRecommendationPushNotfEnabledLoading: false,
      newFeaturedPushNotfEnabledLoading: false,
      newEpFromSubEmailNotfEnabledLoading: false,
      newRecommendationEmailNotfEnabledLoading: false,
      newFeaturedEmailNotfEnabledLoading: false,
      newsletterEmailNotfEnabledLoading: false,
    };
  },

  methods: {
    toggleAllNotfDisabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.allNotfDisabledLoading = true;
      this.currentUser.toggleAllNotfDisabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.allNotfDisabledLoading = false;
          if (!this.currentUser.all_notf_disabled) { this.askPushNotification({ force: true }); }
        });
    },
    toggleNewEpFromSubPushNotfEnabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.newEpFromSubPushNotfEnabledLoading = true;
      this.currentUser.toggleNewEpFromSubPushNotfEnabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.newEpFromSubPushNotfEnabledLoading = false;
          if (this.currentUser.new_ep_from_sub_push_notf_enabled) { this.askPushNotification({ force: true }); }
        });
    },
    toggleNewRecommendationPushNotfEnabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.newRecommendationPushNotfEnabledLoading = true;
      this.currentUser.toggleNewRecommendationPushNotfEnabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.newRecommendationPushNotfEnabledLoading = false;
        });
    },
    toggleNewFeaturedPushNotfEnabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.newFeaturedPushNotfEnabledLoading = true;
      this.currentUser.toggleNewFeaturedPushNotfEnabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.newFeaturedPushNotfEnabledLoading = false;
        });
    },
    toggleNewEpFromSubEmailNotfEnabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.newEpFromSubEmailNotfEnabledLoading = true;
      this.currentUser.toggleNewEpFromSubEmailNotfEnabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.newEpFromSubEmailNotfEnabledLoading = false;
        });
    },
    toggleNewRecommendationEmailNotfEnabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.newRecommendationEmailNotfEnabledLoading = true;
      this.currentUser.toggleNewRecommendationEmailNotfEnabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.newRecommendationEmailNotfEnabledLoading = false;
        });
    },
    toggleNewFeaturedEmailNotfEnabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.newFeaturedEmailNotfEnabledLoading = true;
      this.currentUser.toggleNewFeaturedEmailNotfEnabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.newFeaturedEmailNotfEnabledLoading = false;
        });
    },
    toggleNewsletterEmailNotfEnabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.newsletterEmailNotfEnabledLoading = true;
      this.currentUser.toggleNewsletterEmailNotfEnabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.newsletterEmailNotfEnabledLoading = false;
        });
    },
  },
};
</script>
